import { privacyPolicyPl } from "../pages/PrivacyPolicy/privacyPolicyTranslations";
import { termsPagePl } from "../pages/Terms/termsTranslations";

const pl = {
  common: {
    language: "Język",
    polish: "PL",
    english: "EN",
    book: "Zarezerwuj",
    more: "WIĘCEJ",
    cartAria: "Koszyk, liczba produktów: {{count}}",
    homeAria: "Przejdź na stronę główną",
    openMenu: "Otwórz menu",
    expandMenu: "Rozwiń menu {{label}}",
    instagram: "Instagram",
    facebook: "Facebook",
    loading: "WYSYŁANIE...",
    back: "WRÓĆ",
  },
  header: {
    nav: [
      {
        type: "dropdown",
        label: "Strona główna",
        to: "/",
        items: [
          { type: "action", label: "O nas", to: "/o-nas" },
          { type: "action", label: "Wyposażenie", to: "/wyposazenie" },
          { type: "action", label: "Galeria", to: "/galeria" },
          { type: "action", label: "Wirtualny spacer", to: "/wirtualny-spacer" },
        ],
      },
      { type: "action", label: "AI-Checkup", to: "/ai-checkup" },
      { type: "action", label: "Jak zacząć", to: "/jak-zaczac" },
      {
        type: "dropdown",
        label: "Oferta",
        to: "/oferta",
        items: [
          { type: "action", label: "Cennik", to: "/oferta#cennik" },
          { type: "action", label: "Karnety", to: "/karnet" },
          { type: "action", label: "Współpraca", to: "/wspolpraca" },
        ],
      },
      {
        type: "dropdown",
        label: "Kontakt",
        to: "/kontakt",
        items: [
          { type: "action", label: "Lokalizacja", to: "/kontakt#lokalizacja" },
          { type: "action", label: "FAQ", to: "/kontakt#faq" },
        ],
      },
    ],
  },
  footer: {
    menu: "Menu",
    home: "Strona główna",
    offer: "Oferta",
    contact: "Kontakt",
    privacy: "Polityka prywatności",
    terms: "Regulamin",
    stayWithUs: "Zostań z nami",
    email: "Adres e-mail*",
    subscribe: "SUBSKRYBUJ",
    subscribeSuccess: "Dziękujemy za zapis!",
    missingEmail: "Brak wpisanego maila.",
    genericError: "Wystąpił błąd. Spróbuj ponownie.",
    privacyConsentStart: "Akceptuję",
    termsConsent: "regulamin",
    and: "i",
    privacyConsent: "politykę prywatności",
    privacyError: "Musisz zaakceptować regulamin i politykę prywatności.",
  },
  marquee: {
    opening: "JESTEŚMY JUŻ OTWARCI!",
    address: "ul. Krzysztofa Cedry 6, Łódź",
    opening2: "PROMOCJA 50% z AG50",
    address2: "Kod promocyjny ważny do 31.07.2026 r. -50% na wejście",

  },
  cookieBanner: {
    title: "Szanujemy Twoją prywatność",
    text1: "Korzystając ze strony zgadzasz się na użycie ciasteczek.",
    text2a: "Klikając „Akceptuję wszystkie”, wyrażasz zgodę na używanie wszystkich plików cookies zgodnie z naszą",
    privacyPolicy: "Polityką Prywatności",
    text2b: ".",
    text3: "Możesz w każdej chwili zmienić swoje ustawienia w sekcji dotyczącej cookies.",
    customize: "DOSTOSUJ ZGODY",
    rejectAll: "ODRZUCAM WSZYSTKIE",
    acceptAll: "AKCEPTUJĘ WSZYSTKIE",
    preferencesTitle: "Dostosuj zgody",
    options: {
      necessary: {
        title: "Niezbędne",
        description: "Te pliki cookies są konieczne do prawidłowego działania strony – umożliwiają m.in. zapis ustawień prywatności, logowanie, bezpieczeństwo i obsługę podstawowych funkcji serwisu.",
      },
      analytics: {
        title: "Analityczne",
        description: "Pomagają analizować ruch na stronie i zrozumieć, jak użytkownicy korzystają z serwisu.",
      },
      functional: {
        title: "Funkcjonalne",
        description: "Pozwalają zapamiętać Twoje ustawienia i zapewnić bardziej spersonalizowane działanie strony.",
      },
      marketing: {
        title: "Marketingowe",
        description: "Służą do dopasowywania treści reklamowych i mierzenia skuteczności kampanii marketingowych.",
      },
      externalMedia: {
        title: "Media zewnętrzne",
        description: "Umożliwiają wyświetlanie treści osadzonych z zewnętrznych serwisów, np. map, filmów lub widgetów społecznościowych.",
      },
    },
    acceptSelected: "AKCEPTUJĘ WYBRANE",
  },
  home: {
    heroAria: "Hero slider",
    sliderIndicators: "Wskaźniki slajdów",
    slides: [
      {
        id: "s1",
        title: "Siłownia premium na wyłączność",
        subtitle: "Trenuj bez tłumów, na topowym sprzęcie, w prestiżowym wnętrzu.",
        primaryLabel: "ZAREZERWUJ",
        primaryTo: "/rezerwacja#kalendarz",
        secondaryLabel: "JAK ZACZĄĆ",
        secondaryTo: "/jak-zaczac",
      },
      {
        id: "s2",
        title: "Jesteś trenerem personalnym?",
        subtitle: "Dołącz do naszego zespołu już dziś!",
        primaryLabel: "WSPÓŁPRACA",
        primaryTo: "/wspolpraca",
      },
      {
        id: "s3",
        title: "AI checkup",
        subtitle: "Precyzyjna diagnostyka oparta o dane i sztuczną inteligencję",
        primaryLabel: "UMÓW CHECKUP",
        primaryTo: "/ai-checkup",
      },
    ],
    about: {
      aria: "O nas",
      title: "O NAS",
      text1: "Tworzymy nową jakość treningu w Łodzi – prywatną, samoobsługową siłownię na wyłączność, dla każdego: od startujących po zaawansowanych. Rezerwujesz online, wchodzisz kodem i przez cały wykupiony czas masz cały lokal tylko dla siebie – bez tłumu, bez kolejek i bez spojrzeń.",
      text2: "Trenujesz sam, z osobą towarzyszącą albo z trenerem personalnym – u nas wszystko jest możliwe. Do tego 100% sprzętu Technogym (ekosystem z nowoczesnymi funkcjami AI), Checkup + Visio, czyste powietrze premium oraz profesjonalne nagłośnienie z Bluetooth.",
    },
    features: {
      items: [
        {
          title: "ZDROWE POWIETRZE",
          desc: "Czystość i regularna dezynfekcja",
          details: [
            "Stały komfort temperatury podczas treningu (bez \"zaduchu\")",
            "Powietrze oczyszczane, nawilżane i jonizowane – lepsze odczucie świeżości",
            "Technologie premium: Panasonic Etherea nano™ X + Sharp",
            "Mikroklimat dopracowany jak w prywatnym studio, nie w typowej siłowni",
          ],
        },
        {
          title: "NOWOCZESNA TECHNOLOGIA",
          desc: "AI i smart checkup",
          details: [
            "Inteligentne systemy wspierające komfort i jakość treningu",
            "Technologie klasy premium pracujące automatycznie w tle",
            "Spójny standard niezależnie od pory dnia i intensywności treningu",
            "Rozwiązania znane z prywatnych studiów i obiektów premium",
          ],
        },
        {
          title: "OSZCZĘDNOŚĆ CZASU",
          desc: "Trenujesz bez kolejek",
          details: [
            "Trening dokładnie w zarezerwowanym czasie – bez czekania",
            "Brak kolejek do sprzętu i przestrzeni",
            "Wszystko gotowe od pierwszej minuty rezerwacji",
            "Maksymalna efektywność każdej wizyty",
          ],
        },
        {
          title: "PEŁNA PRYWATNOŚĆ",
          desc: "Komfort dla każdego",
          details: [
            "Przestrzeń tylko dla Ciebie lub Ciebie i trenera",
            "Brak tłumów i przypadkowych osób",
            "Pełne skupienie na treningu i celu",
            "Komfort psychiczny i swoboda, których nie daje klasyczna siłownia",
          ],
        },
        {
          title: "SPRZĘT PREMIUM",
          desc: "Zaawansowany biomechanicznie",
          details: [
            "Sprzęt firmy Technogym",
            "Gwarancja najlepszej jakości",
            "Pełna ergonomia",
            "Standard premium",
          ],
        },
      ],
    },
    equipment: {
      title: "WYPOSAŻENIE",
      desc1: "W całym lokalu korzystasz wyłącznie ze sprzętu Technogym – marki klasy premium, znanej z najwyższej jakości wykonania, ergonomii i dopracowanych detali. To nie jest przypadkowy zestaw maszyn: tworzymy spójny, nowoczesny ekosystem treningowy, w którym urządzenia współpracują z aplikacją, zapisują Twoje treningi i pomagają trenować mądrzej dzięki zaawansowanym funkcjom wspieranym danymi (AI).",
      desc2: "Do dyspozycji masz również Technogym Checkup (diagnostyka i punkt startowy do planu) oraz Technogym Visio, które prowadzi trening krok po kroku na dużym ekranie. Efekt? Profesjonalny standard jak w studiu premium – tylko że na wyłączność i w Twoim tempie.",
      items: [
        { label: "Cardio i diagnostyka", id: "Cardio" },
        { label: "Maszyny siłowe", id: "Maszyny" },
        { label: "Ławki, stojaki i strefa siłowa", id: "Strefa" },
        { label: "Wolne ciężary", id: "Ciezary" },
        { label: "Akcesoria i trening funkcjonalny", id: "Akcesoria" },
      ],
    },
    gallery: {
      title: "GALERIA",
      images: ["Galeria 1", "Galeria 2", "Galeria 3", "Galeria 4"],
    },
    contact: {
      title: "KONTAKT",
      lead1: "Masz pytania lub chcesz dowiedzieć się więcej?",
      lead2: "Skontaktuj się z nami — chętnie pomożemy i rozwiejemy wszelkie wątpliwości.",
      labels: {
        name: "Imię i nazwisko*",
        email: "Adres e-mail*",
        subject: "Temat",
        message: "Wiadomość",
      },
      placeholders: {
        name: "Jan Kowalski",
        email: "name@example.com",
        subject: "Wpisz temat wiadomości",
        message: "Wpisz treść wiadomości",
      },
      errors: {
        name: "Imię jest wymagane.",
        subject: "Temat jest wymagany.",
        emailRequired: "Adres e-mail jest wymagany.",
        emailInvalid: "Niepoprawny format e-mail.",
        message: "Wiadomość nie może być pusta.",
        send: "Wystąpił błąd podczas wysyłania.",
      },
      success: "Wysłano pomyślnie!",
      submit: "WYŚLIJ",
      locationAria: "Podgląd lokalizacji",
      address: "ul. Krzysztofa Cedry 6 Łódź",
    },
  },
  aboutPage: {
    main: {
      title: "O NAS",
      lead: "W Łodzi tworzymy miejsce, którego dotąd brakowało: samoobsługową siłownię na wyłączność – prywatne studio treningowe, gdzie liczy się spokój, komfort i realna jakość.",
      p1: "To rozwiązanie dla każdego: dla osób początkujących, które chcą zacząć bez skrępowania, i dla zaawansowanych, którzy cenią skupienie oraz brak kolejek do sprzętu. U nas nie \"wpadasz na siłownię\" – Ty ją rezerwujesz.",
      p2: "Jak to działa? Rezerwujesz online dzień, godzinę startu i długość treningu. Po płatności dostajesz kod wejścia, który działa tylko w Twoim czasie. Przez cały wykupiony slot lokal jest wyłącznie dla Ciebie – pełna prywatność, pełna swoboda i zero przypadkowych osób obok.",
      p3: "Możesz trenować dokładnie tak, jak chcesz: sam, z osobą towarzyszącą, albo z trenerem personalnym. Chcesz ciszy i skupienia? Możesz. Chcesz treningu w duecie? Możesz. Chcesz wejść z trenerem i mieć prywatną przestrzeń? Też możesz. U nas wszystko jest możliwe – bo to Ty masz kontrolę nad swoim treningiem.",
      claimWhite: "STAWIAMY NA JAKOŚĆ",
      claimRed: "BEZ KOMPROMISÓW",
    },
    details: {
      aria: "Szczegóły",
      image1: "Trening",
      image2: "Sprzęt Technogym",
      image3: "Strefa treningowa",
      premiumTitle: "Sprzęt premium",
      premiumP1: "W środku postawiliśmy na standard premium: 100% sprzętu to Technogym – profesjonalna marka, znana z inteligentnych rozwiązań i spójnego ekosystemu treningowego.",
      premiumP2: "Trening może być wspierany danymi i nowoczesnymi funkcjami (AI), a postęp staje się mierzalny.",
      premiumP3: "Dodatkowo oferujemy Technogym CheckUp — diagnostykę i raport, który pozwala ocenić formę oraz monitorować postępy, oraz Technogym Visio – prowadzenie treningu krok po kroku na dużym ekranie, w Twoim tempie.",
      bookCheckup: "UMÓW CHECKUP",
      appTitle: "Aplikacja Technogym",
      appP1: "W tym ekosystemie ważną rolę gra aplikacja Technogym dostępna za darmo dla naszych klientów (konto jest przypisane do lokalu).",
      appP2: "Aplikacja zapisuje Twoje treningi, porządkuje historię i postępy oraz ułatwia start każdego wejścia: logujesz się na urządzenia (np. kodem/QR), a sprzęt zapamiętuje Twoje ustawienia.",
      appP3: "Możesz też w aplikacji układać lub generować plan treningowy pod cel i dostępny czas, a potem wykonać go na siłowni — plan w domu, realizacja na miejscu.",
      appDownload: "Pobierz aplikację Technogym:",
      qrPlaceholder: "Miejsce na kod QR",
      qrTitle: "Pobierz aplikację",
      qrText: "Zeskanuj kod QR, aby przejść do aplikacji Technogym.",
      qrAlt: "Kod QR do aplikacji Technogym",
      comfortTitle: "Komfortowy i zdrowy trening",
      comfortP1: "Dbamy też o to, co w treningu często niedoceniane: powietrze i mikroklimat. Podczas wysiłku oddychasz intensywniej i potrzebujesz więcej tlenu, dlatego zastosowaliśmy rozwiązania klasy premium: klimatyzację Panasonic Etherea z nanoe X oraz Sharp KI-TX100EU-H – premium oczyszczacz z jonizacją Plasmacluster i nawilżaniem.",
      comfortP2: "Uzupełniają to regularne procedury higieniczne (w tym ozonowanie) oraz dopracowana atmosfera lokalu.",
      comfortP3: "Warunki ustawiasz dokładnie tak, jak lubisz dzięki smart home Grenton – temperatura i natężenie oświetlenia w jednym miejscu, z możliwością tworzenia scen. A klimat dopełnia dźwięk: profesjonalne nagłośnienie Denon + JBL i Bluetooth, żebyś trenował przy swojej muzyce, w swoim rytmie.",
    },
  },
  virtualWalk: {
    title: "Wirtualny spacer",
    descriptionLine1: "Skorzystaj z wirtualnego spaceru i zobacz naszą siłownię bez wychodzenia z domu.",
    descriptionLine2: "Poznaj przestrzeń Alfa Gym i przekonaj się, jak wygląda trening na Twoich zasadach.",
    panoramaAlt: "Panorama Alfa Gym",
    viewerHint: "Przeciągnij, aby rozglądać się po sali. Użyj scrolla lub szczypania, aby przybliżyć.",
    loading: "Ładowanie wirtualnego spaceru...",
    error: "Nie udało się załadować wirtualnego spaceru. Spróbuj ponownie później.",
  },
  underConstruction: {
    labelTop: "Podstrona",
    labelBottom: "w budowie",
    headlineTop: "Wkrótce",
    headlineBottom: "Dostępna",
  },
  reservation: {
    top: {
      title: "Zarezerwuj",
      lead: "Rezerwacja w naszej samoobsługowej siłowni jest szybka i intuicyjna.",
      p1: "Wystarczy wybrać dogodny dzień oraz godzinę treningu, a następnie zarezerwować przedział czasowy dopasowany do Twoich potrzeb.",
      p2: "Wszystkie zajęte terminy są widoczne w kalendarzu, dzięki czemu od razu wiesz, które godziny są już zarezerwowane i możesz łatwo zaplanować swój trening.",
      howItWorks: "jak to działa",
    },
    details: {
      title: "JAK TO DZIAŁA?",
      steps: [
        {
          title: "1. Wybierz datę",
          text: "W kalendarzu zobaczysz wyłącznie te dni, w których są jeszcze wolne miejsca. Dzięki temu masz pewność, że każda wybrana data jest faktycznie dostępna.",
        },
        {
          title: "2. Określ długość treningu",
          text: "Zdecyduj, ile czasu chcesz poświęcić na trening. Na tej podstawie system zaproponuje możliwe godziny rozpoczęcia.",
        },
        {
          title: "3. Wybierz godzinę treningu",
          text: "Spośród sugerowanych przedziałów czasowych wybierz godzinę, która najlepiej pasuje do Twojego planu dnia. Widoczne są tylko wolne terminy.",
        },
      ],
      trainingTitle: "4. Wybierz rodzaj treningu",
      trainingIntro: "Dopasuj trening do swoich potrzeb:",
      trainingOptions: [
        "samodzielnie — pełna swoboda i prywatność",
        "z osobą towarzyszącą — trenuj razem z kimś bliskim",
        "z trenerem personalnym — wybierz profesjonalistę z naszej bazy trenerów i trenuj pod jego okiem",
        "z trenerem personalnym w 2 osoby — wspólny trening dla Ciebie i osoby towarzyszącej, prowadzony przez jednego trenera",
      ],
      coachTitle: "5. Wybierz trenera personalnego",
      coachText: "Jeśli zdecydujesz się na trening z trenerem, wybierz specjalistę dla siebie lub dla siebie i drugiej osoby z listy współpracujących z nami trenerów personalnych. Każdy profil zawiera podstawowe informacje, dzięki którym łatwiej dopasujesz trenera do swoich celów treningowych.",
      trainers: "Nasi Trenerzy",
      pricingText: "Warto zapoznać się z cennikiem, w którym znajdziesz szczegółowe informacje o kosztach poszczególnych rodzajów treningu. Ceny różnią się w zależności od wybranej formy — treningu samodzielnego, z osobą towarzyszącą lub z trenerem personalnym (indywidualnie lub w 2 osoby).",
      priceList: "Cennik",
      warningAlt: "Uwaga",
      warningText: "Prosimy o zwrócenie szczególnej uwagi na 15-minutowe przerwy pomiędzy treningami. W tym czasie przeprowadzane jest ozonowanie pomieszczenia, dlatego bardzo ważne jest punktualne opuszczenie siłowni zgodnie z godziną zakończenia rezerwacji.",
      imageAlt: "Zdjęcie tła",
    },
    checkoutBlocked: "Otwieramy 08.07 — rezerwacje możliwe od tego dnia. Wybierz późniejszy termin!",
    noCoach: "Brak trenera",
    slotTaken: "Wybrany termin jest już zajęty. Wybierz inną godzinę.",
    saved: "Rezerwacja została zapisana pomyślnie!",
    saveError: "Błąd podczas zapisywania rejestracji!",
    expiredCart: "Rezerwacja z koszyka została już zarezerwowana i opłacona lub wygasła.",
    trainerConsent: {
      title: "Ważna informacja o rezerwacji z trenerem",
      text: "AlfaGym jako klub nie zapewnia trenera w ramach tej rezerwacji.\n\nPrzy opcji wejścia z trenerem przychodzisz z własnym trenerem, z którym umawiasz się i rozliczasz we własnym zakresie.\n\nJeśli nie masz swojego trenera, możesz skontaktować się z trenerami współpracującymi z AlfaGym, których listę znajdziesz w zakładce Oferta / Współpraca, i indywidualnie ustalić z nimi szczegóły treningu.\n\nJeśli Twój trener nie znajduje się jeszcze na liście, powinien wcześniej skontaktować się z nami, przejść weryfikację i zostać dodany do naszej bazy. Po dodaniu trenera do systemu będzie można wybrać go podczas rezerwacji bez dodatkowej opłaty za jego wejście.",
      checkbox: "Potwierdzam, że zapoznałem/am się z tą informacją.",
      requiredError: "To pole jest wymagane.",
      cancel: "Wróć",
      confirm: "Rozumiem",
    },
    stepsTitles: {
      date: "Data rezerwacji",
      duration: "Długość treningu",
      startTime: "Godzina rozpoczęcia",
      trainingType: "Rodzaj treningu",
      coach: "Trener personalny",
      summary: "Podsumowanie",
    },
  },
  checkout: {
    title: "PODSUMOWANIE",
    deletedPackage: "Usunięto pakiet z koszyka",
    bookingRemoved: "Rezerwacja została usunięta.",
    bookingDeleteError: "Wystąpił błąd podczas usuwania rezerwacji.",
    summary: {
      title: "Wybrane produkty",
      empty: "Brak produktów w koszyku",
      bookGym: "Zarezerwuj siłownię",
      total: "SUMA DO ZAPŁATY",
      reservationInfo: "Twoje rezerwacje zostaną wprowadzone do kalendarza bezpośrednio po pozytywnej realizacji płatności.",
      trainingTypeMap: {
        individual: "Indywidualny",
        two_people: "2 osoby",
        one_plus_trainer: "1 osoba + trener",
        two_plus_trainer: "2 osoby + trener",
      },
    },
  },
  offer: {
    section: {
      title: "Oferta",
      leadTitle: "Prywatna siłownia na wyłączność",
      leadAccent: "rezerwujesz, wchodzisz kodem i trenujesz po swojemu.",
      leadText: "Wybierasz dzień, godzinę startu i długość wejścia. W czasie rezerwacji lokal jest tylko dla Ciebie (lub dla Was) — bez tłumu, bez kolejek i bez presji. Trenujesz solo, w duecie lub z trenerem personalnym — u nas wszystko jest możliwe.",
      passTitle: "Jeśli trenujesz regularnie, wybierz karnet.",
      passText: "10 wejść w wybranym wariancie czasu i liczby osób. Karnet jest ważny 30 dni od zakupu. Po upływie terminu ważności niewykorzystane wejścia nie przechodzą na kolejny okres.",
      book: "Zarezerwuj termin",
      contact: "Kontakt",
    },
    pricing: {
      title: "Cennik",
      time: "Czas",
      price: "Cena",
      pass: "Karnety",
      package: "Pakiet",
      soloTitle: "Wejścia SOLO (1 osoba)",
      soloDesc: "Dla osób, które chcą maksymalnej prywatności, spokoju i pełnego skupienia.",
      duetTitle: "Wejścia DUET (2 osoby)",
      duetDesc: "Dla par i znajomych, którzy chcą trenować razem — bez obcych osób w tle.",
      checkupTitle: "Badanie CheckUp",
      checkupDesc: "Dla osób, które chcą w jednej sesji poznać realny obraz swojej sprawności, kondycji i potencjału treningowego — w konkretnych liczbach.",
      warning: "Pakiety są ważne 90 dni od zakupu. Po upływie terminu ważności niewykorzystane badania nie przechodzą na kolejny okres",
      buyPass: "KUP KARNET",
    },
    info: {
      topClaimWhite: "SOLO, DUET, TRENER",
      topClaimRed: "TY WYBIERASZ!",
      trainerTitle: "Trener personalny",
      trainerP1: "Trener personalny wchodzi bez dodatkowych opłat.",
      trainerP2: "Możliwe warianty prowadzenia treningu:",
      trainerOptions: ["1 klient + trener", "2 klientów + trener"],
      trainerP3: "Ważne: aby wejście trenera było możliwe, trener musi być dodany do naszego systemu jako współpracujący. Podczas rezerwacji wybierasz z listy swojego trenera personalnego.",
      trainerP4: "Zachęcamy do współpracy trenerów personalnych na specjalnych warunkach.",
      cooperation: "Współpraca",
      reservationTitle: "Rezerwacje indywidualne",
      reservationP1: "Potrzebujesz niestandardowego czasu? Jest taka możliwość: dłuższe bloki, cały dzień na wyłączność, sesje zdjęciowe/wideo oraz nagrania do mediów społecznościowych.",
      reservationP2: "W takich przypadkach prosimy o kontakt – przygotujemy indywidualną wycenę i dopasujemy dostępność.",
      contact: "Kontakt",
      bottomClaimWhite: "POTRZEBUJESZ DŁUŻEJ?",
      bottomClaimRed: "DA SIĘ ZROBIĆ!",
    },
    faq: {
      title: "Najczęściej zadawane pytania",
      items: [
        {
          q: "Czym jest AlfaGym?",
          a: "AlfaGym to siłownia premium stworzona dla osób, które chcą trenować w spokojnych, komfortowych warunkach, bez tłumów i przypadkowego chaosu.\n\nTo miejsce dla osób, które cenią prywatność, wysoką jakość sprzętu i możliwość pełnego skupienia się na treningu.\n\nW AlfaGym korzystasz z nowoczesnego, zaawansowanego sprzętu wspieranego przez sztuczną inteligencję, który pomaga trenować bardziej świadomie i lepiej dopasować ćwiczenia do Twoich celów. Na miejscu dostępne są również udogodnienia audio oraz rozwiązania wspierające czyste, komfortowe powietrze podczas treningu, dzięki czemu cała przestrzeń sprzyja lepszemu samopoczuciu i koncentracji.",
          defaultExpanded: true,
        },
        {
          q: "Dla kogo jest AlfaGym?",
          a: "AlfaGym jest dla osób, które chcą trenować świadomie, wygodnie i w kameralnych warunkach.\n\nSprawdzi się zarówno u osób początkujących, jak i u tych, które trenują regularnie i szukają miejsca o wyższym standardzie.\n\nTo dobra opcja, jeśli chcesz:\n• zacząć ćwiczyć bez stresu,\n• poprawić sylwetkę,\n• zbudować siłę,\n• zadbać o zdrowie i kondycję,\n• trenować bez tłumów,\n• korzystać z profesjonalnego sprzętu,\n• mieć bardziej indywidualne podejście.",
        },
        {
          q: "Czy AlfaGym jest odpowiednia dla osób początkujących?",
          a: "Tak, AlfaGym jest dobrym miejscem dla osób początkujących.\n\nNie musisz mieć doświadczenia ani znać wszystkich ćwiczeń. Możesz rozpocząć spokojnie, we własnym tempie i skorzystać ze wsparcia naszego zespołu.\n\nJeśli nie wiesz, od czego zacząć, pomożemy dobrać odpowiedni kierunek treningu do Twojego celu i aktualnych możliwości.",
        },
        {
          q: "Czy mogę trenować samodzielnie?",
          a: "Tak, w AlfaGym możesz trenować samodzielnie.\n\nKorzystasz z przestrzeni i sprzętu w komfortowych, kameralnych warunkach, bez tłumów i pośpiechu. Możesz skupić się na swoim treningu, pracować we własnym tempie i korzystać z dostępnych udogodnień.",
        },
        {
          q: "Ile osób może wejść do siłowni?",
          a: "W siłowni może trenować 1 lub 2 osoby (w zależności od wybranego wariantu) oraz opcjonalnie trener personalny.",
          defaultExpanded: false,
        },
        {
          q: "Czy podczas rezerwacji ktoś jeszcze będzie w lokalu?",
          a: "Nie. W czasie Twojego slotu siłownia jest wyłącznie dla Ciebie (lub Was).",
          defaultExpanded: false,
        },
        {
          q: "Czy mogę przyjść z trenerem personalnym?",
          a: "Tak. Trener wchodzi bezpłatnie, ale musi być dodany do naszego systemu jako współpracujący. Przy rezerwacji wybierasz trenera z listy.",
        },
        {
          q: "Czy trener może wejść z dwoma osobami?",
          a: "Tak — możliwy jest wariant: trener + 2 osoby.",
        },
        {
          q: "Czy mogę zarezerwować więcej niż 3 godziny / cały dzień?",
          a: "Tak — rezerwacje niestandardowe realizujemy po kontakcie (dłuższe bloki, cały dzień).",
        },
        {
          q: "Czy mogę zrobić sesję zdjęciową lub nagrania do social media?",
          a: "Tak — po kontakcie ustalamy czas, zasady i wycenę.",
        },
        {
          q: "Jak dostanę się do środka?",
          a: "Po rezerwacji otrzymujesz kod dostępu aktywny tylko w Twoim przedziale czasowym.",
        },
        {
          q: "Solo vs duet — co dokładnie oznacza duet?",
          a: "Duet to wejście dla dwóch osób w jednym slocie, na wyłączność.",
        },
        {
          q: "Gdzie znajdę szczegóły współpracy dla trenerów?",
          a: "W zakładce „Trener personalny – współpraca”.",
        },
      ],
    },
  },
  gymPassPackages: {
    title: "KARNETY",
    lead: "Wybierz karnet dopasowany do Twoich celów treningowych.",
    leadRed1: "Jeśli trenujesz regularnie, wybierz karnet: 10 wejść w wybranym wariancie czasu i liczby osób.",
    buy: "KUP PAKIET",
    infoEyebrow: "Ważne informacje",
    infoTitle: "Jak działa karnet",
    info1: "Karnet jest ważny <strong>45 dni</strong> od zakupu. Po upływie terminu ważności niewykorzystane wejścia nie przechodzą na kolejny okres.",
    info2: "Po zakupie karnetu otrzymasz indywidualny kod. Używasz tego samego kodu przy każdej rezerwacji w ramach 10 wejść. Podczas rezerwacji wybierz opcję <strong>„Wykorzystaj karnet”</strong> i wpisz otrzymany kod. System automatycznie odliczy wykorzystane wejście, a po rezerwacji wyśle na Twój adres e-mail informację o liczbie pozostałych wejść.",
    description: {
      eyebrow: "Opis karnetów",
      title: "W cenie każdego karnetu",
      items: [
        "Dostęp do siłowni premium",
        "Trening bez tłumów i kolejek",
        "Zaawansowany sprzęt treningowy",
        "Zapis wyników w aplikacji Technogym",
        "Komfortowa, kameralna przestrzeń",
        "Czyste powietrze i udogodnienia audio",
      ],
    },
  },
  payment: {
    successTitle: "Płatność zakończona sukcesem!",
    successText: "Potwierdzenie rezerwacji wysłaliśmy na Twój adres e-mail.",
    successCta: "wróć do kalendarza",
    failedTitle: "Płatność nie powiodła się...",
    failedText: "Nie udało się zrealizować transakcji. Spróbuj ponownie lub wybierz inną metodę płatności.",
    failedCta: "wróć do płatności",
  },
  notFound: {
    title: "404",
    eyebrow: "Nie ten kierunek",
    subtitle: "Tu trening się urwał, ale możemy szybko wrócić na właściwy tor.",
    text: "Strona, której szukasz, nie istnieje lub została przeniesiona.",
    highlightTraining: "Trening",
    highlightRecovery: "Regeneracja",
    highlightStrength: "Siła",
    backHome: "POWRÓT DO STRONY GŁÓWNEJ",
    seeOffer: "ZOBACZ OFERTĘ",
    tileOneLabel: "Najlepszy ruch",
    tileOneValue: "Wróć na start",
    tileTwoLabel: "Alternatywa",
    tileTwoValue: "Sprawdź ofertę",
  },
  checkup: {
    hero: {
      title: "AI CHECKUP",
      features: ["Precyzyjna diagnostyka", "Świadomy trening", "Mierzalne rezultaty"],
      book: "Umów checkup",
      howItWorks: "Jak to działa?",
    },
    advanced: {
      title: "Zaawansowana diagnostyka",
      subtitle: "wspierana przez sztuczną inteligencję",
      description: "W ciągu jednej sesji otrzymujesz pełny obraz swojej sprawności, kondycji i potencjału treningowego — w liczbach, które naprawdę mają znaczenie. To punkt startowy do treningu opartego o dane, a nie domysły.",
      withoutTitle: "Bez checkupu",
      withoutItems: ["Trenujesz „na oko”", "Nie wiesz, czy robisz postęp", "Jeden schemat dla wszystkich", "Efekty trudne do zmierzenia", "Motywacja spada"],
      withTitle: "AI Checkup",
      withItems: ["Trenujesz w oparciu o dane", "Widzisz realny progres", "Trening dopasowany do Ciebie", "Efekty potwierdzone liczbami", "Motywacja rośnie z każdym wynikiem"],
      processTitle: "Jak działa AI Checkup",
      steps: [
        { title: "Kup i umów CheckUp", text: "Skontaktuj się z nami w celu umówienia terminu badania. Możesz kupić i zapłacić za badanie poprzez stronę internetową lub na miejscu w lokalu." },
        { title: "Diagnostyka (ok. 60 min)", text: "W ustalonym wcześniej terminie, w naszej siłowni nastąpi kompleksowe badanie sprawności, siły, mobilności i kondycji na urządzeniu Technogym Checkup." },
        { title: "Analiza AI", text: "System analizuje Twoje wyniki, porównuje je do norm i wylicza m.in. Wellness Age (wiek biologiczny)." },
        { title: "Raport premium", text: "Otrzymujesz szczegółowy, kilkunastostronicowy raport z wynikami i wnioskami." },
        { title: "Aplikacja Technogym", text: "Wszystkie dane zapisują się w aplikacji – masz historię pomiarów i widzisz postęp." },
      ],
      appDownload: "Pobierz aplikację Technogym",
      qrTitle: "Pobierz aplikację",
      qrText: "Zeskanuj kod QR, aby przejść do aplikacji Technogym.",
      qrAlt: "Kod QR do aplikacji Technogym",
      timeline: ["KUP", "UMÓW SIĘ", "POZNAJ WELLNESS AGE"],
      metricsTitle: "Co mierzymy",
      metrics: [
        { title: "Sprawność i funkcja", items: ["siła mięśni", "stabilność", "symetria ciała"] },
        { title: "Mobilność", items: ["zakresy ruchu", "ograniczenia", "wzorce ruchowe"] },
        { title: "Kondycja", items: ["wydolność", "tolerancja wysiłku", "regeneracja"] },
        { title: "Skład ciała", items: ["masa mięśniowa", "tkanka tłuszczowa", "proporcje"] },
        { title: "Wellness Age", items: ["wiek biologiczny", "ogólny poziom sprawności"] },
      ],
    },
    forWhom: {
      title: "DLA KOGO",
      p1: "AI Checkup jest dla każdego, kto chce trenować świadomie i widzieć realne efekty swojej pracy. Sprawdzi się zarówno u osób rozpoczynających przygodę z treningiem, które chcą bezpiecznie i mądrze postawić pierwsze kroki, jak i u tych, którzy trenują regularnie, ale oczekują konkretów, liczb i jasnej informacji o postępach.",
      p2: "To rozwiązanie dla osób wracających do aktywności po przerwie, chcących lepiej poznać możliwości swojego ciała, a także dla wszystkich, którzy cenią nowoczesne technologie, dane i mierzalny progres zamiast zgadywania i treningu „na oko”.",
      claimWhite: "TO NIE JEST\nJEDNORAZOWY TEST.",
      claimRed: "TO FUNDAMENT\nŚWIADOMEGO TRENINGU.",
    },
    packages: {
      title: "PAKIETY AI CHECKUP",
      lead: "Wybierz pakiet dopasowany do Twoich celów treningowych.",
      leadRed: "Plan treningowy GRATIS do każdego badania!",
      buy: "KUP PAKIET",
      valid1: "Pakiety są ważne 90 dni od zakupu.",
      valid2: "Po upływie terminu ważności niewykorzystane badania nie przechodzą na kolejny okres.",
      packages: [
        {
          title: "Checkup Jednorazowy",
          subtitle: "Idealny start i punkt odniesienia",
          bullets: ["pełna diagnostyka stanu ciała", "poznanie swojego Wellness Age", "jasny punkt startowy do treningu", "szczegółowy raport premium", "zapis wyników w aplikacji Technogym", "do każdego pakietu plan treningowy gratis"],
        },
        {
          title: "Pakiet 3 Checkupów",
          subtitle: "Zobacz realny progres w czasie",
          bullets: ["porównanie wyników w czasie", "kontrola postępów treningowych", "lepsza motywacja dzięki widocznym zmianom", "możliwość korekty treningu na podstawie danych", "pełna historia pomiarów w aplikacji", "do każdego pakietu plan treningowy gratis"],
        },
        {
          title: "Pakiet 6 Checkupów",
          subtitle: "Pełna kontrola i długofalowy rozwój",
          bullets: ["długofalowe monitorowanie formy", "maksymalne wykorzystanie danych treningowych", "szybkie wykrywanie stagnacji lub przeciążeń", "świadome budowanie formy krok po kroku", "kompletna dokumentacja zmian w ciele", "do każdego pakietu plan treningowy gratis"],
        },
      ],
      faq: [
        {
          q: "Czym jest AI Check Up w AlfaGym?",
          a: "AI Check Up to kompleksowa analiza Twojej aktualnej formy, która pomaga lepiej zrozumieć swoje ciało i wykorzystać te informacje do bardziej świadomego treningu oraz planu działania.\n\nPodczas check-upu sprawdzamy najważniejsze parametry związane z kondycją, ruchem i sprawnością, a wyniki pomagają określić, nad czym warto pracować w pierwszej kolejności i jak lepiej dopasować trening do Twojego celu, poziomu zaawansowania oraz możliwości.\n\nTo dobry pierwszy krok, jeśli chcesz trenować mądrzej, świadomie i bez przypadkowego dobierania ćwiczeń.",
          defaultExpanded: true,
        },
        {
          q: "Jak wygląda AI Check Up krok po kroku?",
          a: "Po umówieniu się na usługę AI Check Up otrzymasz krótki formularz dotyczący Twojego stanu zdrowia, aktywności i celu treningowego.\n\nWypełnione informacje zostaną uwzględnione podczas analizy, dzięki czemu cały proces będzie lepiej dopasowany do Ciebie.\n\nPo przyjeździe do AlfaGym nasz pracownik przeprowadzi analizę Check Up na miejscu. Całość odbywa się w prosty i komfortowy sposób, a przez każdy etap przeprowadzimy Cię krok po kroku.\n\nW praktyce wygląda to tak:\n1. Umawiasz się na usługę AI Check Up.\n2. Otrzymujesz krótki formularz do wypełnienia.\n3. W formularzu odpowiadasz na pytania dotyczące zdrowia, aktywności i celu treningowego.\n4. Przyjeżdżasz do AlfaGym w umówionym terminie.\n5. Nasz pracownik wykonuje analizę Check Up.\n6. Po zakończeniu badania otrzymujesz szczegółowy raport oraz plan treningowy wygenerowany przez zaawansowaną sztuczną inteligencję.\n\nPamiętaj: aby wykonać analizę AI Check Up, musisz posiadać aplikację Technogym. Warto zainstalować ją przed wizytą, żeby cały proces przebiegł sprawnie.",
        },
        {
          q: "Czy mogę samodzielnie wykonać AI Check Up?",
          a: "Nie, badania AI Check Up nie wykonuje się samodzielnie.\n\nUrządzenie Check Up jest wyłączone z samodzielnego użytku i może być obsługiwane wyłącznie przez przedstawiciela AlfaGym.\n\nBadanie przeprowadza pracownik naszej siłowni, który został odpowiednio przeszkolony w obsłudze urządzenia i całego procesu analizy. Dzięki temu masz pewność, że check-up zostanie wykonany prawidłowo, bezpiecznie i zgodnie z procedurą.",
        },
        {
          q: "Jak przygotować się do AI Check Up?",
          a: "Najlepiej przyjść w wygodnym stroju sportowym i nie wykonywać ciężkiego treningu bezpośrednio przed wizytą.\n\nWarto też zabrać wodę i przyjść kilka minut wcześniej, żeby spokojnie rozpocząć analizę.\n\nDobrze, jeśli przed check-upem wiesz, jaki jest Twój główny cel: redukcja masy ciała, budowa sylwetki, poprawa siły, powrót do formy albo ogólna poprawa zdrowia.",
        },
        {
          q: "Czy AI Check Up pomoże dobrać plan treningowy?",
          a: "Tak, właśnie po to wykonuje się AI Check Up.\n\nWyniki pomagają lepiej dopasować trening do Twojego poziomu, celu i możliwości. Dzięki temu plan nie jest przypadkowy, tylko oparty o realne dane.\n\nTo szczególnie ważne, jeśli chcesz uniknąć sytuacji, w której ćwiczysz dużo, ale bez konkretnego efektu.",
        },
        {
          q: "Czy AI Check Up jest odpowiedni dla osób początkujących?",
          a: "Tak. AI Check Up jest bardzo dobrym rozwiązaniem dla osób, które dopiero zaczynają.\n\nNa początku najtrudniejsze jest często to, że nie wiadomo, od czego zacząć. Check-up porządkuje sytuację i pokazuje, jaki kierunek będzie dla Ciebie najlepszy.\n\nNie musisz być w formie, żeby przyjść na AI Check Up. To właśnie check-up ma pomóc sprawdzić punkt startowy.",
        },
        {
          q: "Czy warto zrobić AI Check Up, jeśli już trenuję?",
          a: "Tak, zwłaszcza jeśli trenujesz regularnie, ale chcesz lepiej kontrolować postępy.\n\nAI Check Up może pokazać, czy Twoje treningi faktycznie poprawiają to, na czym Ci zależy. Czasem wynik pokaże, że warto zmienić akcent: więcej siły, więcej mobilności, lepsza regeneracja albo inny dobór ćwiczeń.\n\nTo dobra opcja dla osób, które nie chcą trenować „na oko”.",
        },
        {
          q: "Czy AI Check Up zastępuje badanie lekarskie?",
          a: "Nie. AI Check Up nie jest badaniem medycznym i nie zastępuje konsultacji z lekarzem.\n\nTo narzędzie wspierające ocenę sprawności i dobór treningu. Jeśli masz choroby przewlekłe, świeże urazy, silny ból albo przeciwwskazania do wysiłku, skonsultuj się wcześniej z lekarzem lub fizjoterapeutą.\n\nW AlfaGym traktujemy bezpieczeństwo jako podstawę dobrego treningu.",
        },
        {
          q: "Ile trwa AI Check Up?",
          a: "AI Check Up trwa około 60 minut.\n\nWarto zaplanować sobie spokojną wizytę, bez pośpiechu. Dzięki temu możemy dokładnie przeprowadzić analizę, omówić najważniejsze informacje i przygotować dla Ciebie szczegółowy raport oraz plan treningowy wygenerowany przez zaawansowaną sztuczną inteligencję.\n\nTo czas, który pozwala nie tylko wykonać badanie, ale też lepiej zrozumieć wyniki i dowiedzieć się, jak wykorzystać je w bardziej świadomym treningu.",
        },
        {
          q: "Jak często warto powtarzać AI Check Up?",
          a: "Najlepiej powtarzać AI Check Up regularnie, żeby sprawdzać postępy i aktualizować kierunek treningu.\n\nDla większości osób dobrym rytmem będzie wykonanie check-upu co kilka tygodni, zależnie od celu i intensywności treningów.\n\nRegularny pomiar pomaga zobaczyć, czy ciało faktycznie zmienia się w dobrą stronę.",
        },
        {
          q: "Czy AI Check Up jest bezpieczny?",
          a: "Tak, AI Check Up jest nieinwazyjny i przeprowadzany w komfortowych warunkach.\n\nJego celem jest lepsze poznanie Twojego punktu startowego i dopasowanie treningu do Twoich możliwości.\n\nJeśli masz jakiekolwiek ograniczenia, ból lub obawy, powiedz o tym przed rozpoczęciem. Dzięki temu analiza i dalsze rekomendacje będą lepiej dopasowane do Ciebie.",
        },
      ],
    },
  },
  cooperation: {
    top: {
      title: "Współpraca",
      heading: "TRENER PERSONALNY / FIZJOTERAPEUTA",
      accent: "Prowadź klientów w prywatnym studio premium w Łodzi",
      p1: "Zapraszamy trenerów personalnych, fizjoterapeutów i specjalistów od przygotowania motorycznego do współpracy.",
      p2: "Oferujemy komfortową, prywatną przestrzeń na wyłączność oraz sprzęt premium Technogym z nowoczesnymi funkcjami, które ułatwiają prowadzenie treningu i budowanie długofalowych efektów u klienta.",
      cta: "Skontaktuj się z nami",
    },
    benefits: {
      title: "Dlaczego warto współpracować?",
      items: [
        { title: "Prywatność i komfort pracy z klientem", desc: ["siłownia na wyłączność w slocie – zero przypadkowych osób w tle", "świetne warunki do nauki techniki, korekcji i pracy 1:1 / 2:1", "komfort psychiczny klienta (idealne także dla początkujących i osób wracających po przerwie)"] },
        { title: "100% sprzętu Technogym (premium)", desc: ["cały lokal wyposażony wyłącznie w Technogym – spójny standard, ergonomia i jakość", "profesjonalne maszyny, wolne ciężary i akcesoria – trening siłowy, funkcjonalny i uzupełniający w jednym miejscu", "sprzęt premium, który podnosi wartość Twojej usługi"] },
        { title: "Technologia, która ułatwia prowadzenie treningu", desc: ["Technogym Visio – prowadzenie treningu krok po kroku na dużym ekranie (czytelność, porządek w planie, mniej chaosu)", "ekosystem Technogym – spójne doświadczenie treningowe i możliwość pracy w oparciu o dane"] },
        { title: "Aplikacja Technogym – wygodna praca z klientem", desc: ["plan, historia treningów i postępy w jednym miejscu", "łatwiejsza komunikacja i kontrola regularności (między sesjami)", "trening bardziej uporządkowany: plan w aplikacji -> realizacja na siłowni"] },
      ],
    },
    trainer: {
      title: "Jak działa wejście z trenerem?",
      subtitle: "Jeśli klient ma już swojego trenera/fizjo i chce trenować z nim u nas:",
      steps: [
        "kontaktujesz się z nami, a my dodajemy Cię do systemu jako trener współpracujący",
        "od tego momentu klient podczas rezerwacji wybiera z listy Twoje nazwisko",
        "dzięki temu system rozpoznaje wejście „z trenerem” i trener wchodzi bezpłatnie (klient nie płaci dodatkowo za obecność trenera)",
      ],
      sessionConfigs: "Możliwe konfiguracje sesji:",
      configs: ["1 klient + trener", "2 klientów + trener"],
      coachesList: "Lista współpracujących trenerów personalnych",
    },
    details: {
      aria: "Szczegóły współpracy",
      title1: "Technogym Checkup dla Twoich klientów",
      accent1: "na specjalnych warunkach",
      p1: "Współpracując z nami możesz wykonywać Technogym Checkup dla swoich klientów jako element procesu treningowego/terapeutycznego: diagnostyka, punkt startu, mierzalny progres i kontrola postępów. Checkup dla trenerów jest dostępny na specjalnych warunkach – do uzgodnienia po kontakcie. Szczegóły badania znajdziesz też w zakładce „AI – Checkup”.",
      title2: "Promocja trenerów na naszej stronie",
      p2: "Dla trenerów i specjalistów współpracujących z nami oferujemy również możliwość prezentacji / reklamy na naszej stronie internetowej (np. profil, specjalizacja, linki do kontaktu i social media). Zakres promocji i warunki ustalamy indywidualnie — wszystko do omówienia w zależności od formy współpracy.",
      title3: "Rezerwacje specjalne",
      accent3: "sesje, nagrania, dłuższe bloki",
      p3: "Potrzebujesz dłuższego czasu na pracę z klientem, chcesz zrobić sesję wideo lub nagrania do social media? U nas jest taka możliwość — ustalamy indywidualnie po kontakcie.",
    },
    trainers: {
      title: "Współpracują z nami",
      comingSoon: "Trenerzy wkrótce pojawią się w tej sekcji.",
      qualifications: "Kwalifikacje",
    },
    contact: {
      title: "Skontaktuj się z nami",
      p1: "Chcesz dodać się do systemu i wchodzić z klientami bez opłaty za trenera?",
      p2: "Napisz do nas krótko:",
      bullets: ["czym się zajmujesz", "w jakim modelu pracujesz", "i jakie terminy Cię interesują"],
      pBold: "— odezwiemy się z ustaleniami.",
      arrowAlt: "czerwona strzałka",
    },
  },
  contactPage: {
    formTitle: "Formularz kontaktowy",
    formLead1: "Masz pytania dotyczące treningów lub współpracy?",
    formLead2: "Napisz do nas – odpowiemy tak szybko, jak to możliwe.",
    privacyConsentStart: "Akceptuję",
    terms: "regulamin",
    and: "i",
    privacy: "politykę prywatności",
    privacyError: "Musisz zaakceptować regulamin i politykę prywatności.",
    locationTitle: "Lokalizacja",
    gymLocationTitle: "Lokalizacja naszej siłowni",
    gymLocationText: "To jest dokładna lokalizacja naszej siłowni i wskazówki jak do niej dotrzeć.",
    parkingTitle: "Lokalizacja parkingu dla naszych klientów",
    parkingText: "Tu znajduje się miejsce parkingowe dla naszych klientów.",
  },
  equipmentPage: {
    panelFeatures: "Najważniejsze cechy",
    panelSpecs: "Specyfikacja",
  },
  virtualWalkPage: {
    title: "Wirtualny spacer",
    lead: "Skorzystaj z wirtualnego spaceru i zobacz naszą siłownię bez wychodzenia z domu.<br/>Poznaj przestrzeń alfaGym i przekonaj się, jak wygląda trening na Twoich zasadach.",
    panoramaAlt: "Panorama Alfa Gym",
  },
  reportIssuePage: {
    title: "Zgłoś usterkę",
    lead1: "Przekaż nam szczegóły problemu.",
    lead2: "Uzupełnij formularz, a zgłoszenie zostanie zapisane jako dokument w kolekcji Firestore.",
    labels: {
      fullName: "Imię i nazwisko",
      email: "Adres e-mail",
      reportDate: "Data zgłoszenia",
      description: "Opis usterki",
      photos: "Zdjęcia (maks. {{count}})",
    },
    placeholders: {
      fullName: "Jan Kowalski",
      description: "Opisz, co nie działa, gdzie występuje problem i kiedy został zauważony.",
    },
    photos: {
      hint: "Możesz dodać do {{count}} zdjęć z galerii lub aparatu.",
      add: "Dodaj zdjęcie",
      removeAria: "Usuń zdjęcie {{name}}",
      removeTitle: "Usuń zdjęcie",
    },
    errors: {
      fullName: "Podaj imię i nazwisko.",
      emailRequired: "Podaj adres e-mail.",
      emailInvalid: "Podaj poprawny adres e-mail.",
      description: "Opisz usterkę.",
      photosCount: "Możesz dodać maksymalnie {{count}} zdjęcia.",
      photosSize: "Maksymalny rozmiar zdjęcia to {{maxMb}} MB. Pominięto: {{names}}.",
      submit: "Nie udało się wysłać zgłoszenia.",
    },
    submit: "Wyślij zgłoszenie",
    successTitle: "Zgłoszenie zapisane",
    successId: "Identyfikator zgłoszenia: {{id}}",
  },
  calendar: {
    next: "Następny",
    previous: "Poprzedni",
    today: "Dzisiaj",
    month: "Miesiąc",
    week: "Tydzień",
    day: "Dzień",
  },
  checkoutForm: {
    fullNameRequired: "Podaj pełne imię i nazwisko",
    emailInvalid: "Niepoprawny format e-mail",
    phoneShort: "Numer telefonu jest za krótki",
    smsConsent: "Musisz zaakceptować powiadomienia SMS",
    termsConsent: "Musisz zaakceptować regulamin i politykę prywatności",
    companionRequired: "Podaj imię i nazwisko osoby towarzyszącej",
    companionFormat: "Podaj imię i nazwisko (oddzielone spacją)",
    passCode: "Wprowadź kod karnetu",
    companyRequired: "Nazwa firmy jest wymagana",
    invalidNip: "Nieprawidłowy numer NIP",
    streetRequired: "Ulica jest wymagana",
    zipFormat: "Kod pocztowy musi mieć format XX-XXX",
    cityRequired: "Miasto jest wymagane",
    passExpired: "Karnet wygasł",
    passEmpty: "Brak wolnych wejść na karnecie",
    passMismatch: "Karnet jest na rezerwacje na {{time}}min {{type}}, a wybrano inne zajęcia.",
    purchasesBlocked: "Koszyk zawiera rezerwację terminu sprzed otwarcia 08.07. Usuń ją, aby kontynuować.",
    applyPassFirst: "Proszę najpierw zatwierdzić karnet przyciskiem ZASTOSUJ",
    invalidVoucher: "Kod promocyjny jest nieprawidłowy",
    serverError: "Błąd serwera. Spróbuj później.",
    connectionError: "Błąd połączenia z serwerem.",
    passOnlyReservations: "Karnet obsługuje tylko rezerwacje. Usuń inne przedmioty z koszyka, aby go użyć.",
    invalidPassCode: "Nieprawidłowy kod karnetu.",
    passOnlyCount: "Masz tylko {{left}} wejść, a w koszyku jest {{count}} treningów.",
    passProcessingError: "Błąd podczas procesowania karnetu",
    fieldsPrefix: "Proszę uzupełnić wymagane pola: {{fields}}",
    fieldsMap: {
      clientName: "Imię i nazwisko",
      clientEmail: "Adres e-mail",
      clientPhoneNumber: "Numer telefonu",
      smsConsent: "Zgoda na powiadomienia SMS",
      regulaminConstent: "Akceptacja regulaminu",
      accompanyingName: "Imię i nazwisko osoby towarzyszącej",
      passCode: "Kod karnetu",
      companyName: "Nazwa firmy",
      nip: "NIP",
      street: "Ulica",
      zipCode: "Kod pocztowy",
      city: "Miasto",
    },
    trainingTypeMap: {
      individual: "Indywidualny",
      two_people: "2 osoby",
      one_plus_trainer: "1 osoba + trener",
      two_plus_trainer: "2 osoby + trener",
    },
    section1: "1. Twoje dane",
    sectionCompanion: "Osoba towarzysząca",
    section2: "2. Płatność",
    section3: "3. Zniżki",
    labels: {
      fullName: "Imię i nazwisko*",
      email: "Adres e-mail",
      phone: "Numer telefonu",
      acceptAll: "Akceptuję wszystkie zgody",
      acceptTermsStart: "Akceptuję",
      terms: "regulamin",
      and: "i",
      privacy: "politykę prywatności",
      sms: "Wyrażam zgodę na otrzymywanie wiadomości tekstowych dotyczących aktualizacji zamówienia",
      newsletter: "Chcę się zapisać na newsletter",
      companion: "Imię i nazwisko*",
      paynow: "Zapłać z Paynow",
      usePass: "Wykorzystaj karnet",
      onSite: "Zapłać na miejscu",
      passCode: "Kod karnetu",
      invoice: "Chcę otrzymać fakturę",
      companyName: "Nazwa firmy",
      nip: "NIP",
      street: "Ulica",
      zipCode: "Kod pocztowy",
      city: "Miasto",
      promoCode: "Kod promocyjny",
      total: "SUMA DO ZAPŁATY",
      buy: "Kupuję i płacę",
    },
    placeholders: {
      fullName: "Jan Kowalski",
      email: "imienazwisko@gmail.com",
      phone: "+48 641 154 798",
      companyName: "Moja Firma Sp. z o.o.",
      street: "ul. Sportowa 1",
      city: "Warszawa",
      promoCode: "--- --- ---",
    },
    actions: {
      remove: "USUŃ",
      apply: "ZASTOSUJ",
      passActive: "KARNET AKTYWNY: {{code}}",
      promoActive: "AKTYWNY KOD: {{code}}",
    },
  },
  privacyPolicy: privacyPolicyPl,
  termsPage: termsPagePl,
};

export default pl;
